import * as React from 'react';
import { isTouchScreenDevice } from 'utils/window';
import { withTheme, StyleSheetManager } from 'styled-components';
import { Tooltip, TooltipProps } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import './Tooltip.css';
import { FILL_IN_THE_BLANK } from 'constants/questionTypes';
import stylisRTLPlugin from 'stylis-plugin-rtl';
import { TooltipContentWrapper, TooltipContentArrow } from './Tooltip.styled';

interface TooltipElementProps extends TooltipProps {
  classNames?: string;
  children: React.ReactChild;
  tooltipTheme?: 'dark' | 'light' | 'transparent';
  templateTheme?: { [key: string]: any };
  questionType?: string;
  isRtl?: boolean;
}

const TooltipElement = ({ ...props }: TooltipElementProps) => {
  const newProps: TooltipElementProps = props;
  let modifiers;

  if (newProps.questionType === FILL_IN_THE_BLANK) {
    modifiers = {
      preventOverflow: { enabled: false },
      computeStyle: { gpuAcceleration: false },
      hide: { enabled: false }
    };
  } else {
    modifiers = {
      preventOverflow: { boundariesElement: 'viewport' },
      computeStyle: { gpuAcceleration: false }
    };
  }
  newProps.popperOptions.modifiers = modifiers;

  const tooltipContent = (
    <TooltipContentWrapper
      className={newProps.classNames}
      templateTheme={newProps.theme}
      onMouseUp={e => e.stopPropagation()}
    >
      {props.html}
      {props.arrow && <TooltipContentArrow templateTheme={newProps.theme} />}
    </TooltipContentWrapper>
  );

  if (newProps.isRtl || props.html?.props?.theme?.isRtl) {
    newProps.html = (
      <StyleSheetManager stylisPlugins={[stylisRTLPlugin]}>{tooltipContent}</StyleSheetManager>
    );
  } else {
    newProps.html = tooltipContent;
  }

  newProps.arrow = false;
  return (
    <Tooltip {...newProps} theme={newProps.tooltipTheme}>
      {newProps.children}
    </Tooltip>
  );
};

TooltipElement.defaultProps = {
  popperOptions: {
    positionFixed: isTouchScreenDevice()
  },
  useContext: true,
  stickyDuration: 0,
  tooltipTheme: 'light',
  animateFill: false,
  arrow: false
};

export default withTheme(TooltipElement);
